module.exports = __webpack_public_path__ + "assets/ef87482c92662e8b69a21f47588474ea.js";